module.exports = __webpack_public_path__ + "img/social_icon_instagram.93060848.png";